module.exports = "<svg id=\"b89c59d5-9430-4895-ab2c-b9ba58f6ea3c\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><rect width=\"50\" height=\"50\"></rect><path d=\"M25,9.43A10.43,10.43,0,0,0,14.34,20a12.53,12.53,0,0,0,.87,4A94.65,94.65,0,0,0,25,40.57C29.55,33.81,32.07,30.38,35,24a12.3,12.3,0,0,0,.62-4A10.46,10.46,0,0,0,25,9.43Z\" style=\"fill: #fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 507
// module chunks = 1